import React from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { VoucherRevokeType } from "../../enums";
import { VoucherRevokePerks } from "../../types";
import DesktopPerksMatrix from "./DesktopPerksMatrix";
import MobilePerksMatrix from "./MobilePerksMatrix";

interface Props {
  onChangeType(type: VoucherRevokeType): void;
  selectedType?: VoucherRevokeType;
  voucherRevokePerks: VoucherRevokePerks;
}

const VoucherRevokePerksMatrix = ({
  onChangeType,
  selectedType,
  voucherRevokePerks,
}: Props) => {
  const isMinTablet = useMediaQuery({ minWidth: 768 });

  return (
    <Container className="voucher-revoke-perks-matrix">
      {isMinTablet ? (
        <DesktopPerksMatrix
          onChangeType={onChangeType}
          selectedType={selectedType}
          voucherRevokePerks={voucherRevokePerks}
        />
      ) : (
        <MobilePerksMatrix
          onChangeType={onChangeType}
          selectedType={selectedType}
          voucherRevokePerks={voucherRevokePerks}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  color: #616161;

  .ribbon {
    background: #7eb441;
    border-top-right-radius: 6px;
    color: white;
    font-size: 0.75rem;
    font-weight: 400;
    padding: 0.375rem 0.875rem 0.25rem 0.875rem;
    position: absolute;
    right: -0.4375rem;
    top: 0.5rem;
    border-color: #437908;

    &:after {
      position: absolute;
      content: "";
      top: 100%;
      background-color: transparent !important;
      width: 0;
      height: 0;

      left: auto;
      right: 0;
      border-style: solid;
      border-width: 0.5rem 0.375rem 0 0;
      border-color: transparent;
      border-top-color: inherit;
    }
  }
`;

export default VoucherRevokePerksMatrix;
